// workbookList.js

import React, {Component} from "react";
import {connect} from "react-redux";
import cx from "classnames";
import map from "lodash/map";
import _ from "lodash";
import PropTypes from "prop-types";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from "react-sortable-hoc";
import uuidv4 from "uuid/v4";
import {saveWorkbook, getWorkbook} from "../../actions/workbookActions";
import {getSessionId, getDocDetails} from "../../actions/workbook";
import {addFlashMessage} from "../../actions/flashMessages";
import DrivePage from "./Drives/DrivePage";
import ComputerDrivePage from "./Drives/ComputerDrivePage";
import {Collapse} from "reactstrap";
import Formater from "./Drives/common/Formater";
import InvitationPage from "../dashboard/InvitationPage";
import ModalPopup from "../common/ModalPopup";
import PopupContainer2 from "../common/PopupContainer2";
import PopupTypeTwo from "../common/PopupTypeTwo";
import Loader from "../common/Loader";
import {
  LAYOUT_TYPE,
  SPREADSHEET_TYPE,
  IMAGE_TYPE,
  DATA_TYPE,
  TEXT_TYPE,
  NOTEBOOK_TYPE,
} from "../../utils/types";
import {createPreviewImgSrc} from "../../utils/utils";
import {
  getFileThumbnial,
  getFileType,
  getExtention,
} from "../../utils/helper";

import s from "./WorkbookPage.module.css";
import {FormattedMessage} from "react-intl";
import intelMessages from "../../messages";
import {
  Drawer,
  Button,
  Space,
  Tooltip,
  Tag,
  Typography,
  message,
  Card,
  Image,
  Avatar,
  Popconfirm,
  Divider,
  Spin,
  Modal,
  Popover,
  Form,
  Input
} from "antd";
import CustomScrollbars from "../../utils/CustomScrollbars";
import {
  GoogleOutlined,
  DropboxOutlined,
  WindowsOutlined,
  DesktopOutlined,
  YoutubeOutlined,
  PlayCircleOutlined,
  SaveOutlined,
  UsergroupAddOutlined,
  FileAddOutlined,
  CalendarOutlined,
  DragOutlined,
  EditOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CloudServerOutlined,
  PlusOutlined,
  LeftOutlined,
  RightOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import UppyPage from "./UppyPage";
import CKEditor from "./CKEditor";
import axios from "axios";
// import CfeIndex from "./cfe";
var $ = require("jquery");
require("jquery-mousewheel");
require("malihu-custom-scrollbar-plugin");

//
// let CATEGORY_DEFAULT = {
// 	IMAGE: { name: 'Pictures', icons: '/images/drive-icon/icon-01.png' },
// 	LAYOUT: { name: 'PDFs', icons: 'images/drive-icon/icon-02.png' },
// 	SPREADSHEET: { name: 'Excels', icons: 'images/drive-icon/icon-03.png' },
// 	GOOGLE_SPREADSHEET: { name: 'Google Sheets', icons: 'images/drive-icon/icon-04.png' },
// 	TEXT: { name: 'Word Documents', icons: 'images/drive-icon/icon-05.png' },
// 	GOOGLE_TEXT: { name: 'Google Docs', icons: 'images/drive-icon/icon-06.png' },
// 	VIDEO: { name: 'Videos', icons: 'images/drive-icon/icon-04.png' },
// 	DATA: { name: 'Power Point', icons: 'images/drive-icon/icon-06.png' },
// 	GOOGLE_DATA: { name: 'Google Slides', icons: 'images/drive-icon/icon-01.png' },
// 	NOTEBOOK: { name: 'Smart Notebook', icons: 'images/drive-icon/icon-07.png' }
// };
//
const AddPopoverContent = ({
                             addWhiteBoardToWorkbook,
                             index,
                             openFaEditor,
                             openCanvasEditor,
                           }) => {
  return (
    <>
      <Space direction="vertical">
        <Button onClick={() => addWhiteBoardToWorkbook(index)} block>
          Add Whiteboard
        </Button>
        <Button onClick={() => openFaEditor(index)} block>
          Create Content Slide
        </Button>
        {/** Make this work for creating canvas */}
        {false && (
          <Button onClick={() => openCanvasEditor(index)} block>
            Create Canvas Slide
          </Button>
        )}
      </Space>
    </>
  );
};

const DragHandle = SortableHandle(({slide}) => (
  <Tooltip title={"Re-Arrange Slide"}>
    <DragOutlined
      style={{
        fontSize: 20,
        color: "#02a2de",
        cursor: "pointer",
      }}
      className="icon"
    />
  </Tooltip>
));

const SortableItem = SortableElement(
  ({
     count,
     item,
     removeSlide,
     previewSlide,
     addWhiteBoardToWorkbook,
     openFaEditor,
     openCanvasEditor,
   }) => (
    <>
      <li
        style={{zIndex: 10, padding: "12px 10px"}}
        className="gx-module-nav-label"
      >
        <Card
          bodyStyle={{padding: 0, margin: 0}}
          className="gx-profileon gx-poin ter gx-border"
          cover={
            <Image
              key={uuidv4()}
              src={item.path}
              style={{minHeight: 100, maxHeight: 180}}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = item.thumbnail;
              }}
              fallback="data:image/png;base64,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"
              className="gx-rounded-lg"
            />
          }
        >
          <Card.Meta
            className="text-center m-1"
            title={
              <Typography.Paragraph ellipsis>{item.name}</Typography.Paragraph>
            }
            description={
              <div className="gx-text-grey">
                <Space size={"large"} split={<Divider type="vertical"/>}>
                  <DragHandle/>

                  <Popconfirm
                    placement="bottomRight"
                    title={"Are you sure to delete this slide?"}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => removeSlide(item)}
                  >
                    <Tooltip title="Delete slide">
                      <DeleteOutlined
                        style={{
                          fontSize: 20,
                          color: "#02a2de",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </Popconfirm>
                </Space>
              </div>
            }
          />
        </Card>
      </li>
      <Popover
        content={
          <AddPopoverContent
            addWhiteBoardToWorkbook={addWhiteBoardToWorkbook}
            index={count + 1}
            openFaEditor={openFaEditor}
            openCanvasEditor={openCanvasEditor}
          />
        }
        trigger={["click"]}
      >
        <li
          key={uuidv4()}
          className={cx("gx-text-center gx-align-items-center")}
        >
          <Button shape="circle" type="primary" icon={<PlusOutlined/>}/>
        </li>
      </Popover>
    </>
  )
);

const SortableList = SortableContainer(
  ({
     setRef,
     items,
     removeSlide,
     previewSlide,
     addWhiteBoardToWorkbook,
     openFaEditor,
     openCanvasEditor,
   }) => (
    <ul className="gx-module-nav">
      <Popover
        content={
          <AddPopoverContent
            addWhiteBoardToWorkbook={addWhiteBoardToWorkbook}
            key={uuidv4()}
            openFaEditor={openFaEditor}
            openCanvasEditor={openCanvasEditor}
          />
        }
        trigger={["click"]}
      >
        <li
          key={uuidv4()}
          className={cx("gx-mt-4 gx-text-center gx-align-items-center")}
        >
          <Button shape="circle" type="primary" icon={<PlusOutlined/>}/>
        </li>
      </Popover>

      {items.map((item, index) => (
        <SortableItem
          key={uuidv4()}
          index={index}
          item={item}
          removeSlide={removeSlide}
          count={index}
          previewSlide={previewSlide}
          addWhiteBoardToWorkbook={addWhiteBoardToWorkbook}
          openFaEditor={openFaEditor}
          openCanvasEditor={openCanvasEditor}
        />
      ))}
    </ul>
  )
);

class WorkbookPage extends Component {
  constructor() {
    super();
    this.state = {
      aiPopoverVisibility: false,
      invitationVisibility: false,
      uppyVisible: false,
      ckEditorVisible: false,
      workbook: {},
      isLoading: true,
      slides: [],
      slideHandler: {
        currentSlide: -1,
        totalSlides: 0,
        previewPath: "",
      },
      faModalVisible: false,
      canvasModalVisible: false,
      faSlideIndex: 0,
      canvasSlideIndex: 0,
      isDirty: false,
      aiSlides: [],
      contentSlideText: "",
    };
  }

  componentDidMount = () => {
    const {location, getWorkbook, addFlashMessage} = this.props;
    const workbookId = location.query.id;

    getWorkbook({workbookId})
      .then((res) => {
        const {workbook} = res.data;
        this.setState({
          workbookId,
          workbook: workbook,
          slides: workbook.slide,
          isLoading: false,
          slideHandler: {
            ...this.state.slideHandler,
            totalSlides: workbook.slide.length,
          },
        });
      })
      .catch((error) => {
        console.error(error);
        message.error("Oops, you request failed. Please try in again.");
      });
  };

  addFromUppy = (file) => {
    let {slides} = this.state;
    const record = {
      drive: "uppy",
      name: file.name,
      mimeType: file.type,
      downloadFileType: file.extension,
      downloadLink: file.uploadURL,
      thumbnail:
        file.preview ||
        file.data.thumbnail ||
        file.data.icon ||
        "/images/thumbnails/img-04.jpg",
    };
    slides.push(record);

    this.setState({
      isDirty: true,
      slides,
      slideHandler: {...this.state.slideHandler, totalSlides: slides.length},
    });
  };

  addCKEditorSlide = (urlPath) => {
    // this._uppy.uppyDrive.getPlugin("Url").addFile(url);
    let {slides, faSlideIndex} = this.state;

    const record = {
      drive: "uppy",
      downloadLinkType: "link",
      downloadLink: urlPath,
      thumbnail: urlPath,
      name: "Contribute Cloud Slide",
      downloadFileType: `image`,
    };

    slides.splice(faSlideIndex, 0, record);
    this.setState({
      isDirty: true,
      slides,
      faModalVisible: false,
      slideHandler: {...this.state.slideHandler, totalSlides: slides.length},
    });
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    if (oldIndex !== newIndex) {
      this.setState({
        isDirty: true,
        slides: arrayMove(this.state.slides, oldIndex, newIndex),
      });
    }
  };

  addWhiteBoardToWorkbook = (index) => {
    let {slides} = this.state;

    const record = {
      drive: "uppy",
      downloadLinkType: "link",
      downloadLink: `${process.env.REACT_APP_BASE_URL}/images/blank.png`,
      thumbnail: `${process.env.REACT_APP_BASE_URL}/images/blank.png`,
      name: "White Board",
      downloadFileType: `image`,
    };
    slides.splice(index, 0, record);

    // slides.push(record);

    this.setState({
      isDirty: true,
      slides,
      slideHandler: {...this.state.slideHandler, totalSlides: slides.length},
    });
  };

  prepareSlides = () => {
    const {slides, workbookId} = this.state;
    const data = slides;
    const dbSlides = [];
    const slidesDownloadLinks = [];
    data.forEach((s, i) => {
      let dbRecored = {};
      if (s.path) {
        dbRecored = s;
      } else {
        const downloadDetails = {};
        dbRecored.name = s.name;
        dbRecored.thumbnail = s.thumbnail;

        const ext = /^.+\.([^.]+)$/.exec(s.name);
        const extention = ext == null ? "" : ext[1].toLocaleLowerCase();
        const downloadName = `${i}-${workbookId}.${extention}`;
        if (IMAGE_TYPE.indexOf(extention.toUpperCase()) > -1) {
          dbRecored.thumbnail = `/lecture-attachments/${downloadName}`;
        } else if (
          LAYOUT_TYPE.indexOf(extention.toUpperCase()) > -1 ||
          SPREADSHEET_TYPE.indexOf(extention.toUpperCase()) > -1 ||
          DATA_TYPE.indexOf(extention.toUpperCase()) > -1 ||
          TEXT_TYPE.indexOf(extention.toUpperCase()) > -1 ||
          NOTEBOOK_TYPE.indexOf(extention.toUpperCase()) > -1
        ) {
          dbRecored.thumbnail = `/lecture-attachments/${downloadName}-0.png`;
        }

        dbRecored.path = `/lecture-attachments/${downloadName}`;
        dbRecored.filetype = s.downloadFileType;

        downloadDetails.drive = s.drive;
        downloadDetails.downloadLink = s.downloadLink;
        downloadDetails.name = s.name;
        downloadDetails.downloadName = downloadName;
        downloadDetails.downloadLinkType = s.downloadLinkType;
        downloadDetails.downloadFileType = s.downloadFileType;

        slidesDownloadLinks.push(downloadDetails);
      }

      dbSlides.push(dbRecored);
    });

    return {workbookId, dbSlides, slidesDownloadLinks};
  };
  saveSlide = () => {
    const {saveWorkbook, addFlashMessage} = this.props;
    const {workbookId, dbSlides, slidesDownloadLinks} = this.prepareSlides();
    this.setState({isLoading: true});
    saveWorkbook({workbookId, dbSlides, slidesDownloadLinks})
      .then((res) => {
        this.setState({isLoading: false});
        addFlashMessage({
          type: "success",
          text: "Your slides have been saved",
        });

        this.props.getWorkbook({workbookId}).then((res) => {
          const {workbook} = res.data;
          this.setState({isDirty: false, workbook, slides: workbook.slide});
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({isLoading: false});
        addFlashMessage({
          type: "error",
          text:
            "Oops, something went wrong while fetching data from the server",
        });
      });
  };

  removeSlide = (removeSlide) => {
    const {slides} = this.state;
    const finalSlides = _.reject(slides, removeSlide);
    this.setState({
      isDirty: true,
      slides: finalSlides,
      slideHandler: {
        ...this.state.slideHandler,
        totalSlides: this.state.slideHandler.totalSlides - 1,
      },
    });
  };

  startLecture = async () => {
    const {saveWorkbook, getSessionId, addFlashMessage} = this.props;
    const {workbookId, dbSlides, slidesDownloadLinks} = this.prepareSlides();
    try {
      this.setState({isLoading: true});
      await saveWorkbook({workbookId, dbSlides, slidesDownloadLinks});
      addFlashMessage({type: "success", text: "Your slides have been saved"});

      let result = await getSessionId();
      const {sessionId} = result.data;
      this.context.router.push({
        pathname: "/lecture",
        query: {id: workbookId, sessionId: sessionId},
      });
      this.setState({isLoading: false});
    } catch (error) {
      console.error(error);
      this.setState({isLoading: false});
      addFlashMessage({
        type: "error",
        text: "Oops, something went wrong while fetching data from the server",
      });
    }
  };

  addFromMyFilesWorkbook = (file) => {
    let {slides} = this.state;

    const record = {
      drive: "uppy",
      name: file.filename,
      mimeType: file.mimetype,
      downloadFileType: getExtention(file.filename),
      downloadLink: `${process.env.REACT_APP_BASE_URL}${file.path}`,
      thumbnail: "/images/thumbnails/img-04.jpg",
    };

    slides.push(record);

    this.setState({
      isDirty: true,
      slides,
      slideHandler: {...this.state.slideHandler, totalSlides: slides.length},
    });
  };

  render() {
    const {
      invitationVisibility,
      uppyVisible,
      ckEditorVisible,
      faModalVisible,
      canvasModalVisible,
      workbook,
      slides,
      isLoading,
      isDirty,
    } = this.state;
    return (
      <Spin spinning={isLoading}>
        <div className="gx-main-content">
          <div
            style={{margin: "-33px -32px -5px -33px"}}
            className="gx-app-module"
          >
            <div className="gx-module-sidenav gx-d-none gx-d-lg-flex">
              <div className="gx-module-side">
                <div className="gx-module-side-header">
                  <div className="gx-module-logo">
                    <span
                      className="gx-mb-1 gx-text-truncate"
                      style={{maxWidth: 200}}
                    >
                      {workbook.name}
                    </span>
                  </div>
                </div>
                <div className="gx-module-side-content">
                  <CustomScrollbars className="gx-module-side-scroll">
                    <SortableList
                      setRef={this.setRef}
                      removeSlide={this.removeSlide}
                      previewSlide={() => {
                      }}
                      addWhiteBoardToWorkbook={this.addWhiteBoardToWorkbook}
                      openFaEditor={(index) =>
                        this.setState({
                          faModalVisible: true,
                          faSlideIndex: index,
                        })
                      }
                      openCanvasEditor={(index) =>
                        this.setState({
                          canvasModalVisible: true,
                          canvasSlideIndex: index,
                        })
                      }
                      items={slides}
                      onSortEnd={this.onSortEnd}
                      useDragHandle={true}
                      axis={"y"}
                    />
                  </CustomScrollbars>
                </div>
              </div>
            </div>

            <div className="gx-module-box">
              <div className="gx-module-box-header gx-align-items-center">
                <div className="gx-module-box-header-inner">
                  <div className="gx-module-box-header-right">
                    <Space>
                      <Button
                        onClick={this.startLecture}
                        size={"large"}
                        type="primary"
                        // shape="round"
                        className="gx-pt-0"
                        icon={<PlayCircleOutlined/>}
                      >
                        Save Slides and Start Lecture
                      </Button>

                      <Button
                        onClick={this.saveSlide}
                        size={"large"}
                        type={isDirty ? "danger" : "primary"}
                        // shape="round"
                        className="gx-pt-0"
                        icon={
                          isDirty ? (
                            <ExclamationCircleOutlined/>
                          ) : (
                            <SaveOutlined/>
                          )
                        }
                      >
                        Save Lecture Slide
                      </Button>

                      <Button
                        onClick={() =>
                          this.setState({
                            invitationVisibility: !invitationVisibility,
                          })
                        }
                        size={"large"}
                        type="primary"
                        // shape="circle"
                        className="gx-pt-0"
                        icon={<UsergroupAddOutlined/>}
                      >
                        Invite Participants And Start Lecture
                      </Button>

                      <Popover
                        content={
                          <div style={{maxHeight: 500, overflow: 'auto', maxWidth: 500}}>
                            <Form
                              name="promptForm"
                              labelCol={{span: 24}}
                              wrapperCol={{span: 24}}
                              onFinish={async (values) => {
                                console.log("=>(WorkbookPage.js:655) values", values);
                                const result = await axios.post(`${process.env.REACT_APP_API_HOST}/api/ai/generate-slide`, values)
                                this.setState({aiSlides: result.data.slides})
                              }}
                              autoComplete="off"
                              requiredMark={false}
                            >
                              <Form.Item
                                label="Lecture Topic:"
                                name="lecturePrompt"
                                rules={[{required: true, message: 'Please enter lecture topic'}]}
                              >
                                <Input.TextArea/>
                              </Form.Item>

                              <Form.Item wrapperCol={{offset: 8, span: 16}}>
                                <Button type="primary" htmlType="submit">
                                  Create Slides
                                </Button>
                              </Form.Item>
                            </Form>

                            {this.state.aiSlides.map((itm, index) => <div>
                              <div style={{whiteSpace: 'pre-wrap'}}>{itm}</div>
                              <br/>
                              <Button onClick={() => {
                                this.setState({
                                  faModalVisible: true,
                                  contentSlideText: itm,
                                })
                              }}
                              >
                                Edit Slide {index + 1}
                              </Button>
                              <hr/>
                              <br/>
                            </div>)}
                          </div>
                        }
                        title="Create Slides with AI"
                        trigger="click"
                        placement="bottom"
                        open={this.state.aiPopoverVisibility}
                        onOpenChange={(flag) => this.setState({aiPopoverVisibility: flag})}
                      >
                        <Button
                          size={"large"}
                          type="primary"
                          className="gx-pt-0"
                          icon={<img alt={'ai'} src={"/images/ai.png"}
                                     style={{width: 30, height: 30, marginRight: 15, marginTop: -5}}/>}
                        >
                          Create Slides with AI
                        </Button>
                      </Popover>
                    </Space>
                  </div>
                </div>
              </div>
              <div className="gx-module-box-content gx-d-flex gx-align-items-center gx-justify-content-center">
                {/* <CKEditor addSlide={this.addCKEditorSlide} /> */}
                {/* <Space size={100}>
                  <Tooltip
                    placement="bottom"
                    title="Click To Add Files From your Computer or Cloud Storage"
                  > */}
                <UppyPage
                  uppyVisible={uppyVisible}
                  onRef={(c) => (this._uppy = c)}
                  addFromUppy={this.addFromUppy}
                  toggleUppyVisible={() =>
                    this.setState({uppyVisible: false})
                  }
                  addFromMyFilesWorkbook={this.addFromMyFilesWorkbook}
                />
                {/* <Button
                      onClick={() => this.setState({ uppyVisible: true })}
                      style={{ width: 400, height: 400 }}
                      // size={"large"}
                      type="primary"
                      shape="circle"
                      icon={<CloudServerOutlined style={{ fontSize: 350 }} />}
                    /> */}
                {/* </Tooltip>

                  <Tooltip
                    placement="bottom"
                    title="Click To Create Slide In Editor"
                  >
                    <Button
                      onClick={() => this.setState({ ckEditorVisible: true })}
                      style={{ width: 100, height: 100 }}
                      // size={"large"}
                      type="primary"
                      shape="circle"
                      icon={<FileAddOutlined style={{ fontSize: 50 }} />}
                    />
                  </Tooltip>
                </Space> */}
                {/* <Button
                  onClick={() => this.setState({ ckEditorVisible: true })}
                  style={{
                    position: "absolute",
                    right: 30,
                    bottom: 20,
                    width: 50,
                    height: 50,
                    // background: "#fff",
                    // background: "transparent",
                    boxShadow: "rgba(2, 162, 222, 0.61) 0px 0px 10px 7px",
                  }}
                  type="primary"
                  shape="circle"
                  icon={<FileAddOutlined />}
                /> */}
              </div>
            </div>
          </div>
          <InvitationPage
            workbook={workbook}
            visible={invitationVisibility}
            toggleInvitationModal={() =>
              this.setState({invitationVisibility: !invitationVisibility})
            }
          />
          {/* <UppyPage
            uppyVisible={uppyVisible}
            onRef={(c) => (this._uppy = c)}
            addFromUppy={this.addFromUppy}
            toggleUppyVisible={() => this.setState({ uppyVisible: false })}
          /> */}

          <Modal
            width="85%"
            title="CONTRIBUTE CLOUD SLIDE EDITOR"
            visible={faModalVisible}
            footer={null}
            onCancel={() => {
              this.setState({faModalVisible: false});
            }}
          >
            <CKEditor contentSlideText={this.state.contentSlideText} addSlide={this.addCKEditorSlide}/>
          </Modal>

          {/* {canvasModalVisible && (
            <CfeIndex
              canvasModalVisible={canvasModalVisible}
              onSaveCanvas={async ({ canvasJson, preview }) => {
                this.setState({
                  canvasModalVisible: false,
                  canvasSlideIndex: -1,
                });
                const result = await fetch(preview);
                const resultBlob = await result.blob();

                this._uppy.uppyDrive.addFile({
                  name: `canvas_editor${Math.floor(Math.random() * 1000)}.jpg`, // file name
                  type: "image/jpeg", // file type
                  data: resultBlob, // file blob
                  meta: {
                    // optional, store the directory path of a file so Uppy can tell identical files in different directories apart.
                    // relativePath: webkitFieSystemEntry.relativePath,
                  },
                  source: "Local", // optional, determines the source of the file, for example, Instagram.
                  isRemote: false, // optional, set to true if actual file is not in the browser, but on some remote server, for example,
                  // when using companion in combination with Instagram.
                });
                // console.log(
                //   `file: WorkbookPage.js  :::  line 772  :::  WorkbookPage  :::  render  :::  this._uppy.uppyDrive`,
                //   this._uppy.uppyDrive
                // );

                // console.log(
                //   `file: WorkbookPage.js  :::  line 733  :::  WorkbookPage  :::  render  :::  canvasData`,
                //   canvasJson,
                //   preview
                // );

                // debugger;
              }}
              onClose={() => {
                this.setState({
                  canvasModalVisible: false,
                  canvasSlideIndex: -1,
                });
              }}
            />
          )} */}
        </div>
      </Spin>
    );
  }
}

WorkbookPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(null, {
  saveWorkbook,
  getWorkbook,
  getSessionId,
  getDocDetails,
  addFlashMessage,
})(WorkbookPage);
